import React, { useState, useEffect, useCallback } from "react";
import {
  Modal,
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import s from "./styles.module.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../../hooks/useAuth";

const ShowModal = ({ open, onClose, loading, id }) => {
  const [date, setDate] = useState(null);
  const [time, setTime] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState("");
  //const agent_id = useSelector((state) => state.auth.agent_id);
  const { auth } = useAuth();
  const token = auth?.access_token;

  const navigate = useNavigate();

  const fetchAgentData = useCallback(async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/agents`,
      );
      if (!response.ok) throw new Error("Ошибка при загрузке агента");

      const data = await response.json();
      setAgents(data);
      return data;
    } catch (error) {
      console.error("Ошибка:", error);
      return null;
    }
  }, []);

  const createShowCase = async ({ agentId, showDate, showTime }) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/show_case/create`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            property_id: Number(id),
            agent_id: Number(agentId),
            show_date: showDate,
            show_time: showTime,
          }),
        },
      );

      if (!response.ok) throw new Error("Ошибка при отправке данных");

      setDate(null);
      setTime("");
      setSelectedAgent("");
      toast.success("Успешно отправлено");
      onClose();

      navigate("/shows");
    } catch (error) {
      console.error("Ошибка:", error);
      toast.error("Ошибка: " + error.message);
    }
  };

  useEffect(() => {
    if (open) {
      fetchAgentData().then(setAgents);
    }
  }, [open, fetchAgentData]);

  const handleConfirm = async () => {
    if (!selectedAgent) {
      toast.error("Пожалуйста, выберите агента.");
      return;
    }
    if (!date) {
      toast.error("Пожалуйста, выберите дату.");
      return;
    }
    if (!time) {
      toast.error("Пожалуйста, выберите время.");
      return;
    }
    const formattedDate = date
      ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
      : null;

    await createShowCase({
      property_id: id,
      agentId: selectedAgent,
      showDate: formattedDate,
      showTime: time,
    });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "700px",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Назначить показ</Typography>
          <CloseIcon onClick={onClose} style={{ cursor: "pointer" }} />
        </div>
        <div>
          <div className={s.btnRow}>
            <div className={s.btn}>
              <h5>Выберите дату:</h5>
              <button
                onClick={() => setShowCalendar(true)}
                className={s.btnBox}
              >
                <p>{date ? date.toLocaleDateString() : "Выбрать дату"}</p>
                <CalendarMonthIcon />
              </button>
            </div>

            <div className={s.btn}>
              <h5>Выберите время:</h5>
              <div className={s.btnBox}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    value={time ? dayjs(time, "HH:mm") : null}
                    onChange={(newValue) => setTime(newValue.format("HH:mm"))}
                    ampm={false}
                  />
                </LocalizationProvider>
              </div>
            </div>
          </div>

          {/* Agent Selection Field */}
          <div style={{ marginTop: 20 }}>
            <FormControl fullWidth>
              <InputLabel id="agent-select-label">Выберите агента</InputLabel>
              <Select
                labelId="agent-select-label"
                value={selectedAgent}
                onChange={(e) => setSelectedAgent(e.target.value)}
                label="Выберите агента"
              >
                {agents.map((agent) => (
                  <MenuItem key={agent.id} value={agent.id}>
                    {agent.name || `Агент ${agent.id}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <Modal open={showCalendar} onClose={() => setShowCalendar(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
            }}
          >
            <Calendar
              onChange={(value) => {
                setDate(value);
                setShowCalendar(false);
              }}
              value={date}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 20,
              }}
            >
              <button
                onClick={() => setShowCalendar(false)}
                className="saveButton"
              >
                Закрыть
              </button>
            </div>
          </Box>
        </Modal>

        <div style={{ marginTop: 20 }}>
          <div className="centerLoading">
            {loading ? (
              <div className="loader"></div>
            ) : (
              <button onClick={handleConfirm} className="saveButton">
                Назначить показ
              </button>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ShowModal;
